import { render } from "./WysiwygSection.vue?vue&type=template&id=505c468b"
import script from "./WysiwygSection.vue?vue&type=script&lang=js"
export * from "./WysiwygSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__